import React, { useEffect, useState } from "react";
import { Accordion, Stack, Typography, useTheme } from "@mui/material";
import { Dangerous, ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { getCookie } from "@utils/utilsCookie";
import { cognitoApp } from "@utils/utilsCognito";
import {
  BackCta,
  Container,
  Description,
  IconContainer,
  IssueContainer,
  IssueDetails,
  IssueSummary,
  MessageContainer,
  Title,
} from "@pages/Shared/RedirectError/style";

const RedirectError: React.FC = () => {
  const { t } = useTranslation(["redirectError"]);
  const [issueDescription, setIssueDescription] = useState<string | null>("");
  const theme = useTheme();
  useEffect(() => {
    if (sessionStorage.getItem("adminRedirectMessagePage")) {
      setIssueDescription(sessionStorage.getItem("adminRedirectMessagePage"));
      sessionStorage.removeItem("adminRedirectMessagePage");
    }
  }, []);

  const returnToLogin = () => {
    if (cognitoApp.getCognitoCurrentUser()) {
      cognitoApp.getCognitoCurrentUser()?.signOut(() => {
        window.location.href = `${getCookie("corporate_domain")}/logout` || "";
      });
    } else {
      window.location.href = `${getCookie("corporate_domain")}/logout` || "";
    }
  };

  return (
    <Container>
      <MessageContainer theme={theme}>
        <Stack
          alignItems="center"
          spacing={4}
          sx={{ color: "white", textAlign: "center" }}
        >
          <IconContainer sx={{ display: "flex", justifyContent: "center" }}>
            <Dangerous style={{ fontSize: "60px" }} />
          </IconContainer>
          <Title variant="h3" theme={theme}>
            {t("hero-title")}
          </Title>
          <Description variant="h5" theme={theme}>
            {t("hero-description")}
          </Description>
          <BackCta
            theme={theme}
            variant={"contained"}
            disableRipple={true}
            onClick={returnToLogin}
          >
            <Typography sx={{ textTransform: "none" }}>
              {t("cta-label")}
            </Typography>
          </BackCta>
          {issueDescription && (
            <IssueContainer>
              <Accordion sx={{ backgroundColor: "#1B1B1B" }}>
                <IssueSummary
                  expandIcon={<ExpandMore sx={{ color: "white !important" }} />}
                >
                  <Typography>Technical issue:</Typography>
                </IssueSummary>
                <IssueDetails>
                  <Typography>{issueDescription}</Typography>
                </IssueDetails>
              </Accordion>
            </IssueContainer>
          )}
        </Stack>
      </MessageContainer>
    </Container>
  );
};

export default RedirectError;
